export default "__VITE_ASSET__lexoAk67__"